var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.594,
    height: 20.594,
    viewBox: "0 0 20.594 20.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-search",
    d: "M16.509,13.769a8.144,8.144,0,1,0-2.742,2.739l5.526,5.525,2.74-2.742Zm-6.944.824a5.024,5.024,0,1,1,5.027-5.021,5.032,5.032,0,0,1-5.027,5.021Z",
    transform: "translate(-1.44 -1.44)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchLight);
export default __webpack_public_path__ + "static/media/icon-search-light.3e9d106a4f6773df58a184f0654fe600.svg";
export { ForwardRef as ReactComponent };